export default __webpack_public_path__ + "static/media/m93r.330a9ef0.svg";